var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgEditSvg = function SvgEditSvg(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00899 15H1.60869C1.44726 15 1.29243 14.9359 1.17828 14.8217C1.06413 14.7076 1 14.5527 1 14.3913V10.991C1.00007 10.8298 1.06411 10.6752 1.17804 10.5611L10.561 1.17814C10.6752 1.06407 10.8299 1 10.9913 1C11.1527 1 11.3074 1.06407 11.4216 1.17814L14.8219 4.57616C14.9359 4.6903 15 4.84506 15 5.00643C15 5.16779 14.9359 5.32256 14.8219 5.4367L5.43888 14.822C5.32482 14.9359 5.17021 14.9999 5.00899 15Z",
    stroke: "rgba(120, 126, 153, 1)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30469 3.43481L12.5655 7.69565",
    stroke: "rgba(120, 126, 153, 1)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgEditSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMDA4OTkgMTVIMS42MDg2OUMxLjQ0NzI2IDE1IDEuMjkyNDMgMTQuOTM1OSAxLjE3ODI4IDE0LjgyMTdDMS4wNjQxMyAxNC43MDc2IDEgMTQuNTUyNyAxIDE0LjM5MTNWMTAuOTkxQzEuMDAwMDcgMTAuODI5OCAxLjA2NDExIDEwLjY3NTIgMS4xNzgwNCAxMC41NjExTDEwLjU2MSAxLjE3ODE0QzEwLjY3NTIgMS4wNjQwNyAxMC44Mjk5IDEgMTAuOTkxMyAxQzExLjE1MjcgMSAxMS4zMDc0IDEuMDY0MDcgMTEuNDIxNiAxLjE3ODE0TDE0LjgyMTkgNC41NzYxNkMxNC45MzU5IDQuNjkwMyAxNSA0Ljg0NTA2IDE1IDUuMDA2NDNDMTUgNS4xNjc3OSAxNC45MzU5IDUuMzIyNTYgMTQuODIxOSA1LjQzNjdMNS40Mzg4OCAxNC44MjJDNS4zMjQ4MiAxNC45MzU5IDUuMTcwMjEgMTQuOTk5OSA1LjAwODk5IDE1WiIgc3Ryb2tlPSJyZ2JhKDEyMCwgMTI2LCAxNTMsIDEpIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4zMDQ2OSAzLjQzNDgxTDEyLjU2NTUgNy42OTU2NSIgc3Ryb2tlPSJyZ2JhKDEyMCwgMTI2LCAxNTMsIDEpIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";